import React from 'react';
import DailyPerformance from './DailyPerformance';
import StdRiskTable from './StdRiskTable';
import CumPerfTable from './CumPerfTable';
import GreeksTable from './GreeksTable';
import './PerformanceTable.css';
import Drawdowns from './Drawdowns';
import i18n from '../../../i18n';
import CompText from '../Compliance/CompText';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux'
import { PerfTableLoading } from '../Components/Spinner';
import { SomethingWentWrong } from '../Components/ErrorHandle';

library.add(faCircleNotch);

const Performance = () => {
  const data = useSelector(state => state.fundData.data)
  const loadingPerformanceData = useSelector(state => state.fundData.loadingPerformanceData)
  const errorPerformanceData = useSelector(state => state.fundData.errorPerformanceData)
  const hasLevels = data.filter(x => x.levels !== null);
  const hasLevelsAndDate = data.filter(x => x.levels?.date !== null);
  const hasLevelDailyRoR = data.filter(x => x.levelsDaily && x.levelsDaily.dlyRoR!== null);
  const hasLevelDailyRoRData = hasLevelDailyRoR.length > 0
  const hasPerfData = hasLevels.length > 0 || hasLevelDailyRoR.length > 0


  if (errorPerformanceData){
    return(
      <div className="fund-char-perf">     
        <SomethingWentWrong />
        <div style={{ marginBottom: '65px' }} />
        <CompText pane='Performance' />
      </div>
    )
  }

  if (loadingPerformanceData && !hasLevelDailyRoRData){
    return(
      <div className="fund-char-perf">     
        <PerfTableLoading />
        <div style={{ marginBottom: '65px' }} />
        <CompText pane='Performance' />
      </div>
    )
  }
  
  if (hasPerfData) {
    return (
      <div>
        <div className="fund-char-perf">
          {hasLevelDailyRoR.length > 0? (
            <div>
              <DailyPerformance />       
              <div style={{ marginBottom: '65px' }} />
            </div>
          ) : null}
          {hasLevelsAndDate.length > 0? (
            <div>
              <CumPerfTable />
              <div style={{ marginBottom: '65px' }} />
              <StdRiskTable />
              <div className='fund-char-perf-definitions'> 
                  <strong>{i18n.t('VolatilityKey')}</strong> : {i18n.t('VolatilityDefinition')}
              </div>            
              <GreeksTable title={'Alpha'} data={data} type={'alpha'} />
              <GreeksTable title={'Beta'} data={data} type={'beta'} />
              <GreeksTable title={'Sharpe Ratio'} data={data} type={'sharpeRatio'} />
              <GreeksTable title={'Up Capture'} data={data} type={'upCapture'} />
              <GreeksTable title={'Down Capture'} data={data} type={'downCapture'} />
              <Drawdowns data={data} type={'drawdowns'} />
              <CompText pane='Performance' />
            </div>
          ) : (
            <div>
              <div className='noData'>{i18n.t('no-data')}</div>
              <CompText pane='Performance' />
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <text> something went wrong </text>
    );
  }
}

export default Performance
